// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VC2S","option":"styles_option__1ArXS","active":"styles_active__1EgRI"};